import { axiosClient } from '@nx-frontend/shared/api';
import { NoteDto } from '@nx-frontend/shared/types';
import { generateNoteGlobalId } from '@nx-frontend/shared/utils';

interface CreateWorkspaceFolderParams {
  workspaceId: string;
  folderName?: string;
  parentId?: string;
}

export async function createWorkspaceFolder({
  workspaceId,
  folderName = 'New Folder',
  parentId = 'root',
}: CreateWorkspaceFolderParams): Promise<NoteDto> {
  const folder = (
    await axiosClient.post<NoteDto>(`/v2/api/web-editor/notes/create`, {
      workspaceId,
      noteId: generateNoteGlobalId(),
      note: {
        textVersion: 2,
        title: folderName,
        parentId: parentId,
        type: 'folder',
      },
    })
  ).data;
  return folder;
}
